<template>
  <div v-if="!isJumpSumsub">
    <RegisterTemplate
      :title="$t('verificationStatus.ibtVerification.start.bwtTitle')"
      :isIbtStepper="true"
      :activeTab="activeTab"
      :setActiveTab="setActiveTab"
      :tabs="tabs"
    />
  </div>
  <div v-else class="my-10 flex items-start justify-center gap-10 md:mx-10">
    <RegisterFormContainer
      :title="$t('verificationStatus.ibtVerification.start.bwtTitle')"
      :overflow="true"
      class="flex-1"
    >
      <div class="m-8">
        <SumsubAdvancedKyc @onFailedSumsub="onFailedSumsub" />
      </div>
      <div class="pt-3 pb-8 text-center">
        <el-button class="blue_button" @click="$router.push('/home')">{{ $t('common.button.bkToHm') }}</el-button>
      </div>
    </RegisterFormContainer>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import RegisterFormTab from '@/constants/register/registerFormTab';
import ibtStep from '@/constants/register/ibtStep';
import RegisterTemplate from '@/components/register/registerTemplate/RegisterTemplate.vue';
import ibtStore from '@/store/register/ibtVerification/ibtStore';
import { apiGetSumsubJump } from '@/resource';
import RegisterFormContainer from '@/components/register/registerForms/RegisterFormContainer.vue';
import SumsubAdvancedKyc from '@/components/register/SumsubAdvancedKyc';

const path = 'ibtVerification';

export default {
  name: 'IbtVerification',
  components: { RegisterTemplate, RegisterFormContainer, SumsubAdvancedKyc },
  data() {
    return {
      tabs: [
        new RegisterFormTab({
          step: ibtStep.financialInformation,
          title: 'verificationStatus.ibtVerification.financialInformation.title',
          icon: 'ibtRegister-financial-icon',
          regulator: this.regulator,
          pathName: `${path}/financialInformation`
        }),
        new RegisterFormTab({
          step: ibtStep.confirmId,
          title: 'verificationStatus.ibtVerification.confirmId.title',
          icon: 'ibtRegister-poi-icon',
          regulator: this.regulator,
          pathName: `${path}/confirmId`
        }),
        new RegisterFormTab({
          step: ibtStep.confirmPoa,
          title: 'verificationStatus.ibtVerification.confirmPoa.title',
          icon: 'ibtRegister-poa-icon',
          regulator: this.regulator,
          pathName: `${path}/confirmPoa`
        }),
        new RegisterFormTab({
          step: ibtStep.ibtStatus,
          title: 'verificationStatus.ibtVerification.ibtSuccess.title',
          icon: 'ibtRegister-complete-icon',
          regulator: this.regulator,
          pathName: `${path}/ibtSuccess`
        })
      ],
      isJumpSumsub: false
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    activeTab() {
      return ibtStore.state.activeTab;
    },
    poiTab() {
      return this.tabs[1];
    },
    poaTab() {
      return this.tabs[2];
    },
    underReviewTab() {
      return this.tabs[3];
    },
    isUnderReview() {
      return this.activeTab === this.underReviewTab.step;
    },
    ...mapState('common', ['ibtPoiAuditStatus', 'ibtPoaAuditStatus']),
    ...mapGetters('common', ['isIbtPoiEditable', 'isIbtPoaEditable'])
  },
  watch: {
    isIbtPoiEditable(isIbtPoiEditable) {
      this.setDisabledTabs(isIbtPoiEditable, this.poiTab);
    },
    isIbtPoaEditable(isIbtPoaEditable) {
      this.setDisabledTabs(isIbtPoaEditable, this.poaTab);
    },
    isUnderReview(isUnderReview) {
      this.setUnderReviewTabs(isUnderReview);
    }
  },
  methods: {
    async init() {
      this.isJumpSumsub = await this.getSumsubJump();
      if (!this.isJumpSumsub) {
        this.oldFlowInit();
      }
    },
    async oldFlowInit() {
      if (this.isUnderReview) {
        this.setUnderReviewTabs(this.isUnderReview);
      }

      // $nextTick to enable this.tabs changes to props
      this.$nextTick(() => {
        this.setDisabledTabs(this.isIbtPoiEditable, this.poiTab);
        this.setDisabledTabs(this.isIbtPoaEditable, this.poaTab);
      });

      // Reset when re-init
      ibtStore.dispatch('setStep', ibtStep.financialInformation);
    },
    setDisabledTabs(isEditable, tab) {
      if (isEditable) {
        tab.disabled = false;
      } else {
        tab.disabled = true;
      }
    },
    setUnderReviewTabs(isUnderReview) {
      if (isUnderReview) {
        for (let i = 0; i < this.tabs.length; i++) {
          const currTab = this.tabs[i];
          if (currTab !== this.underReviewTab) {
            currTab.disabled = true;
          }
        }
      } else {
        for (let i = 0; i < this.tabs.length; i++) {
          const currTab = this.tabs[i];
          if (currTab !== this.underReviewTab) {
            currTab.disabled = false;
          }
        }
      }
    },
    setActiveTab(tab) {
      ibtStore.dispatch('setActiveTab', tab);
    },
    async getSumsubJump() {
      const res = await apiGetSumsubJump({
        type: 4 // poa需要传type2区分,advance需要传type4,5区分
      });
      this.isSumsubJump = res.data.data;
      return res.data.data;
    },
    async onFailedSumsub() {
      this.init();
    }
  }
};
</script>

<style lang="scss" scoped></style>
